module.exports = __webpack_public_path__ + "img/MED_EGGS@300x.d0440314.png";